<template>
  <div
    class="metrics-summary-card"
    :class="{
      'metrics-summary-card--clickable': clickable,
      'metrics-summary-card--highlighted': highlighted,
    }"
    @click="clickable && $emit('click')"
  >
    <div class="metrics-summary-card__icon-wrap">
      <eg-icon
        :icon="icon"
        class="metrics-summary-card__icon"
        :color="highlighted ? '#FFFFFF' : 'var(--color-icon-primary-primary)'"
      />
    </div>
    <div class="metrics-summary-card__content">
      <span class="metrics-summary-card__label paragraph-s">{{ label }}</span>
      <span class="metrics-summary-card__value">{{ formattedValue }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MetricsSummaryCard",

  props: {
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
    displayValue: {
      type: String,
      default: null,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    highlighted: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    formattedValue() {
      if (this.displayValue !== null) return this.displayValue;
      return this.value.toLocaleString();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../shared/metrics_card";

.metrics-summary-card {
  @include metrics-card;
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;

  &--clickable {
    cursor: pointer;

    &:hover {
      border-color: var(--color-stroke-primary-default, #7c3aed);
    }
  }

  &--highlighted {
    background: linear-gradient(135deg, #6135c1 0%, #5d33b7 100%);
    border-color: #5d33b7;
    box-shadow: 0 4px 16px rgba(97, 53, 193, 0.24);

    .metrics-summary-card__icon-wrap {
      background: rgba(255, 255, 255, 0.16);
    }

    .metrics-summary-card__label,
    .metrics-summary-card__value {
      color: #ffffff;
    }

    .metrics-summary-card__label {
      opacity: 0.75;
    }
  }

  @media (max-width: 1100px) {
    flex-basis: 30%;
  }

  @media (max-width: 1024px) {
    padding: 16px;
    gap: 12px;
    flex-basis: 45%;
  }

  @media (max-width: 740px) {
    flex-basis: 100%;
  }

  .is-sidebar-minimized & {
    @media (max-width: 740px) {
      flex-basis: 45%;
    }

    @media (max-width: 500px) {
      flex-basis: 100%;
    }
  }

  &__icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: var(--color-surface-primary-light, #ede9ff);
    flex-shrink: 0;
  }

  &__icon {
    font-size: 24px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__label {
    color: var(--color-text-neutral-fade);
    font-weight: var(--typography-font-weight-fw-600, 600);
  }

  &__value {
    color: var(--color-text-neutral-on-white);
    font-family: var(--typography-font-family-text-primary, Inter);
    font-size: 24px;
    font-weight: var(--typography-font-weight-fw-800, 800);
    line-height: 120%;

    @media (max-width: 1024px) {
      font-size: 22px;
    }
  }
}
</style>
